import { render, staticRenderFns } from "./new_chat_button.vue?vue&type=template&id=7599e412"
import script from "./new_chat_button.vue?vue&type=script&lang=js"
export * from "./new_chat_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports